import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'
import {
  getAccountValueLeaderboard,
  getBalanceLeaderboard,
  getGigiLeaderboard,
  getTotalTimeLeaderboard,
  getYourLeaderboardPosition,
} from './api'

import { GetLeaderboardParams } from './types'
import { LEADERBOARD_BATCH_SIZE } from '@/shared/constants'
import { merge } from 'effector'

const getYourLbPositionFx = createEffect(async (userToken: string) => {
  const yourLbPosition = getYourLeaderboardPosition(userToken)
  return yourLbPosition
})

const getLeaderBoardsFx = createEffect(async (userToken: string) => {
  const leaderboards = await Promise.all([
    getAccountValueLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getTotalTimeLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getBalanceLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
    getGigiLeaderboard(userToken, 1, LEADERBOARD_BATCH_SIZE),
  ])
  return leaderboards
})

export const getGamedLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  const response = await getBalanceLeaderboard(params.userToken, params.page, params.size)
  return response.data
})
export const getGigiLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  const response = await getGigiLeaderboard(params.userToken, params.page, params.size)
  return response.data
})
export const getHoursLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  const response = await getTotalTimeLeaderboard(params.userToken, params.page, params.size)
  return response.data
})
export const getAssetsLeaderboardFx = createEffect(async (params: GetLeaderboardParams) => {
  const response = await getAccountValueLeaderboard(params.userToken, params.page, params.size)
  return response.data
})

// test

const allLeaderboardsFailed = merge([
  getGamedLeaderboardFx.failData,
  getGigiLeaderboardFx.failData,
  getHoursLeaderboardFx.failData,
  getAssetsLeaderboardFx.failData,
])

// test

allLeaderboardsFailed.watch(() => {
  onError()
})

export { getLeaderBoardsFx, getYourLbPositionFx }
